import React, { useState, useEffect } from "react";
import { Row, Col, Form, Input, Button, Select, Tooltip } from "antd";
import { CopyOutlined, PlusOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import { defaultValidateMessages } from "./Helper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const TransactionBankInfoUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [activeBankId, setActiveBankId] = useState();
  const [activeVersion, setActiveVersion] = useState();
  const [bankRequirements, setBankRequirements] = useState({});
  const [callbackUrl, setCallbackUrl] = useState();

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
      setActiveBankId(props.data.bankId);
      setActiveVersion(props.data.version);
    }
  }, [props.data]);

  useEffect(() => {
    if (activeBankId) getBankInfoRequirements(activeBankId, props.data?.version);
  }, [activeBankId]);

  useEffect(() => {
    if (activeVersion == 62001) {
      getGarantiCallbackUrl();
    } else {
      setCallbackUrl();
    }

  }, [activeVersion]);

  const getBankInfoRequirements = (bankId, version) => {
    RequestHandler.get(`/Bank/GetBankColumnsByBankId/${bankId}/${version}`).then(
      (response) => {
        setBankRequirements({
          isRequiredAccountInfo: response.isRequiredAccountInfo,
          ...response.bankInfoRequiredColumns,
          ...response.bankInfoAccountRequiredColumns,
          versions: response.versions
        });
      }
    );
  };

  const getGarantiCallbackUrl = () => {
    RequestHandler.get(`/TransactionBankInfo/GarantiApiCallbackUrl`).then((response) => {
      setCallbackUrl(response.data);
    });
  };

  const onActiveVersionChange = (version) => {
    setActiveVersion(version);
    getBankInfoRequirements(activeBankId, version);
  };

  const onFinish = (values) => {
    RequestHandler.put(`/TransactionBankInfo`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        form.resetFields();

        if (props.onSuccess) props.onSuccess();
      }
    }).catch(function (error) {
      setLoading(false);
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  return (
    <>
      <Form
        {...formItemLayout}
        validateMessages={defaultValidateMessages}
        form={form}
        name="bankInfoUpdate"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          <Col span={24}>
            <Form.Item name="id" hidden>
              <Input />
            </Form.Item>

            <Form.Item name="bankId" hidden>
              <Input />
            </Form.Item>

            {bankRequirements && (
              <>

                {bankRequirements.versions?.length > 1 && (
                  <Form.Item
                    label="Versiyon"
                    name="version"
                    initialValue={activeVersion}
                  >
                    <Select
                      placeholder="Seçiniz"
                      value={activeVersion}
                      onChange={onActiveVersionChange}
                    >
                      {bankRequirements.versions.map((item) => (
                        <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}

                {bankRequirements.isUserNameRequired && (
                  <Form.Item
                    label={bankRequirements.userNameLabel ?? "Kullanıcı Adı"}
                    name="userName"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input />
                  </Form.Item>
                )}

                {bankRequirements.isUserCodeRequired && (
                  <Form.Item
                    label={bankRequirements.userCodeLabel ?? "Kullanıcı Kodu"}
                    name="userCode"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input />
                  </Form.Item>
                )}

                {bankRequirements.isPasswordRequired && (
                  <Form.Item
                    label={bankRequirements.passwordLabel ?? "Şifre"}
                    name="password"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input />
                  </Form.Item>
                )}

                {bankRequirements.isCustomerNumberRequired && (
                  <Form.Item
                    label={bankRequirements.customerNumberLabel ?? "Müşteri Numarası"}
                    name="customerNumber"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input />
                  </Form.Item>
                )}

                {bankRequirements.isCorporateCodeRequired && (
                  <Form.Item
                    label={bankRequirements.corporateCodeLabel ?? "Kurum Kodu"}
                    name="corporateCode"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input />
                  </Form.Item>
                )}

                {bankRequirements.isServiceUrlRequired && (
                  <Form.Item
                    label={bankRequirements.serviceUrlLabel ?? "Url"}
                    name="serviceUrl"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input />
                  </Form.Item>
                )}

                {bankRequirements.isFirmNameRequired && (
                  <Form.Item
                    label={bankRequirements.firmNameLabel ?? "Firma Adı"}
                    name="firmName"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input />
                  </Form.Item>
                )}

                {bankRequirements.isFirmKeyRequired && (
                  <Form.Item
                    label={bankRequirements.firmKeyLabel ?? "Firma Anahtarı"}
                    name="firmKey"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input />
                  </Form.Item>
                )}

                {callbackUrl && (
                  <Form.Item
                    label="Tanımlanacak Callback Url"
                    name="callbackUrl"
                    initialValue={callbackUrl}
                  >
                    <Input.Group compact>
                      <Input readOnly value={callbackUrl} style={{ width: 'calc(100% - 36px)' }} />
                      <Tooltip title="Kopyala">
                        <Button icon={<CopyOutlined />} onClick={() => navigator.clipboard.writeText(callbackUrl)} />
                      </Tooltip>
                    </Input.Group>
                  </Form.Item>
                )}
              </>
            )}

            <Col style={{ textAlign: "right" }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Col>
        </Row>
      </Form>
    </>
  );
};
export default TransactionBankInfoUpdateForm;
